import { Accordion, AccordionDetails, Box, styled, Typography } from '@mui/material';

export const UploadBox = styled(Box)(({ theme }) => ({
  position: 'fixed',
  bottom: '10px',
  minWidth: '360px',
  width: '300px',
  right: '24px',
  zIndex: 1300,
  backgroundColor: theme.palette.case.neutral.n0,
  borderRadius: '4px',
  msOverflowStyle: 'none',
  '& ::-webkit-scrollbar': {
    width: '0px !important',
  },
}));

export const UploadAccordion = styled(Accordion)(() => ({
  padding: '12px',
}));

export const UploadAccordionHeader = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '32px',
}));

export const UploadHeaderLeft = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
}));

export const IconWrapper = styled(Box, {
  shouldForwardProp: (prop: string) => !['expand'].includes(prop),
})<{ expand: boolean }>(({ expand }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transform: `rotate(${expand ? '0' : '180deg'})`,
}));

export const UploadHeaderRight = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
}));

export const UploadDetails = styled(AccordionDetails)(() => ({
  padding: 0,
  maxHeight: '200px',
  overflow: 'auto',
  boxSizing: 'border-box',
  scrollbarWidth: 'none',
  marginTop: '8px',
  msOverflowStyle: 'none',
  '& ::-webkit-scrollbar': {
    width: '0px !important',
  },
}));

export const UploadItem = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  paddingTop: '8px',
  paddingBottom: '8px',
}));

export const UploadItemRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const UploadItemLeft = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
}));

export const FileIconWrapper = styled(Box)(({ theme }) => ({
  svg: {
    width: '20px',
    height: '20px',
    path: {
      fill: theme.palette.case.neutral.n500,
    },
  },
}));

export const UploadItemText = styled(Typography, {
  shouldForwardProp: (prop: string) => !['isCancel'].includes(prop),
})<{ isCancel: boolean }>(({ theme, isCancel }) => ({
  maxWidth: isCancel ? '240px' : '276px',
  color: theme.palette.case.neutral.n900,
}));

export const UploadItemProgress = styled(Box)(() => ({
  width: '100%',
}));

export const ErrorText = styled(Typography)(({ theme }) => ({
  color: theme.palette.case.red.r600,
}));
